export const ACTION_RESET = 'FETCH_LINKCARD_RESET';
export const ACTION_REQUEST = 'FETCH_LINKCARD_REQUEST';
export const ACTION_SUCCESS = 'FETCH_LINKCARD_SUCCESS';
export const ACTION_ERROR = 'FETCH_LINKCARD_ERROR';
